import React from 'react';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { SelectBase, Alert } from '../../index';
import { api } from '../../../config/Services';
import { RetrieveRequest } from '../../../utilities/services/RequestService';

class MembershipSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            options: []
        }
    }

    componentDidMount() {
        if (this.props.forceRender) {
            this.retrieveData();
        }
    }

    retrieveData(criteria = {}, inactivefield = {}, actionspage = 'create', exclude = []) {
        let paging = { limit: -1, page: 1 }
        let sort = { membershipname: 'asc' };
        let url = api.url.masterdata.membership.retrieve;
        let column = [];
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ membershipname, membershipid }) => {
                    return {
                        label: membershipname,
                        value: membershipid
                    };
                });
                
                //if options deactive
                const { membershipid, membershipname } = inactivefield;
                if (membershipid) {
                    options = getOptionsDeactive(actionspage, options, membershipid, membershipname);
                }

                if(exclude.length > 0){
                    options = options.filter(obj => !exclude.includes(obj.value) );
                }

                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }

}

export default MembershipSelect;
